(exports.GAME_ID = "5f34e4ec6f609a00179ed677"),
(exports.FORM_ID = "5f34e5666f609a00179ed678"),
(exports.SERVER_URL = "https://api.lucien.ai"),
(exports.BD_NAME = "jeu-promodev");